import { Box, Typography } from "@mui/material";
import { IOffer } from "../../interfaces/IOffer";
import { OfferPositionCheckListOverview } from "./OfferPositionCheckListOverview";
import { IOfferPosition } from "../../interfaces/IOfferPosition";

interface IProps {
    offerArray: IOffer[] | undefined;
    setOfferArray: Function;
}

export const CheckListTab: React.FC<IProps> = ({ offerArray, setOfferArray }) => {
    const updateOfferPosition = (offer: IOffer, offerPosition: IOfferPosition) => {
        const updatedOfferArray = offerArray?.map((existingOffer) => {
            if (existingOffer.id === offer.id) {
                const updatedOfferPositions = existingOffer.OfferPositions.map((position) =>
                    position.id === offerPosition.id ? offerPosition : position,
                );

                return {
                    ...existingOffer,
                    OfferPositions: updatedOfferPositions,
                };
            }
            return existingOffer;
        });

        setOfferArray(updatedOfferArray);
    };

    if (!offerArray) {
        return <>Bitte warten...</>;
    }

    return (
        <>
            <Typography variant="h5" mb={6}>
                Checklisten
            </Typography>

            {offerArray?.map((offer, index) => {
                if (
                    offer.OfferState === 3 &&
                    offer.OfferPositions.some((position) => position.checkListItems.length > 0)
                ) {
                    return (
                        <Box ml={2} mb={3}>
                            {offer.OfferPositions.map((offerPosition, index) => {
                                if (offerPosition.checkListItems.length > 0) {
                                    return (
                                        <OfferPositionCheckListOverview
                                            key={index}
                                            offer={offer}
                                            offerPosition={offerPosition}
                                            updateOfferPosition={updateOfferPosition}
                                        />
                                    );
                                }
                                return null;
                            })}
                        </Box>
                    );
                }
                return null;
            })}
        </>
    );
};
